/** Shopify order ids are numeric; admin-created subscriptions use other values. */
export const isShopifyOrderId = (value?: string | null) =>
  !!value && /^\d+$/.test(value);
